import { UseQueryOptions, useQuery } from 'react-query';
import { DefaultGetResponse } from '~/App/Api/rest';
import axios, { AxiosError } from 'axios';
import { Country } from '~/types/models';

export const queryKeys = {
  detail: ['countries'] as const,
};

export async function getCountries() {
  const res = await axios.get<Country[]>('/api/v3/countries');
  return res.data;
}

export interface UseCountriesParams {
  options?: UseQueryOptions<Country[], AxiosError>;
}

export const useCountries = ({ options }: UseCountriesParams) =>
  useQuery<DefaultGetResponse<Country[]>, AxiosError>(
    queryKeys.detail,
    getCountries,
    options
  );
